import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AppState } from '../app.models';
import { createIsEqualSelector } from '../shared/ngrx/selector.utils';
import * as fromUsers from '../users';
import { devicesFeatureKey, DeviceState, Router } from './devices.models';

const selectFeature = createFeatureSelector<DeviceState>(devicesFeatureKey);

export const selectLoading = createSelector(selectFeature, (state) => state.loading > 0);

export const selectDevices = createIsEqualSelector(
    selectFeature,
    fromUsers.selectLoggedInUser,
    (state: DeviceState, loggedInUser?: fromUsers.LoggedInUser) => state.devices.map((d) => new Router(d, loggedInUser))
);
export const selectCount = createSelector(selectFeature, (state) => state.totalCount);
